import React, { useRef } from "react";
import { Trash2, Plus, Frown, TriangleAlert, CircleCheckBig } from "lucide-react";
import Spacing from "../Spacing";
import { Drawer } from 'vaul';

export default function ConfirmationModal(
  { 
    actionType = () => {}, 
    openModal = false, 
    setOpenModal = () => {}, 
    name='',
    type='',
    setOpacityClass = () => {},
    stopRecording = () => {},
    set_active_modal = () => {},
    previousScrollPosition = 0,
    userInformation = {},
    practiceInformation = {},
  }
) {
  const dropdownRef = useRef(null);

  const handleDrawerClose = () => {
    setOpenModal(false);
    window.scrollTo(0, previousScrollPosition);
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={openModal} onOpenChange={handleDrawerClose} dismissible={false}>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4 small" onPointerDownOutside={(e) => e.preventDefault()} onInteractOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()}>
            <Drawer.Title className="sr-only">Delete Record</Drawer.Title>
            <Drawer.Description className="sr-only">Delete a recorded data</Drawer.Description>
            <div className="docpro_modal_wrap docpro_style_2 docpro_style_auto">
              <div className="docpro_modal">
                <Spacing lg="0" sm="20" />
                <div className="docpro_deleteboxbox modal_height_100">
                  <div>
                    {type === 'delete' ? (
                      <div className="docpro_iconbox_icon docpro_badge_red">
                      <Trash2 width={50} height={50} />
                    </div>
                    ) : type === 'package' ? (
                      <div className="docpro_iconbox_icon docpro_badge_red">
                        <Frown width={50} height={50} />
                      </div>
                    ) : type === 'recording' ? (
                      <div className="docpro_iconbox_icon docpro_badge_red">
                        <TriangleAlert width={50} height={50} />
                      </div>
                    ) : type === 'onboarding_success' ? (
                      <div className="docpro_iconbox_icon docpro_badge_green">
                        <CircleCheckBig width={50} height={50} />
                      </div>
                    ) : (
                      <div className="docpro_iconbox_icon docpro_badge_green">
                        <Plus width={50} height={50} />
                      </div>
                    )}
                    <Spacing lg="20" sm="20" />
                    <div className="docpro_iconbox_right">
                      {type !== 'onboarding_success' ? (
                        <h3 className="docpro_fs_20">Are you Sure?</h3>
                      ) : (
                        <Spacing lg="10" sm="10" />
                      )}
                      {name !== '' ?
                        type === 'delete'?
                          <p className="docpro_mb_0 docpro_fs_16">
                            You want to delete <span className="docpro_red_color font-semibold">{name}</span>?
                          </p>
                        : type === 'package' ?
                          <p className="docpro_mb_0 docpro_fs_16">
                            You want to <span className="docpro_red_color font-semibold">{name}</span>?
                          </p>
                        : type === 'recording' ?
                          <p className="docpro_mb_0 docpro_fs_16">
                            You want to <span className="docpro_red_color font-semibold">{name}</span> this page without save <span className="font-semibold">Transcript</span>?
                          </p>
                        : type === 'onboarding_success' ?
                          <div>
                            <p className="docpro_fs_16 docpro_green_color font-semibold">{name}.</p>
                            <p className="docpro_mb_0 docpro_fs_15" style={{ display: 'inline-flex', flexDirection: 'column', textAlign: 'left' }}>
                              <span style={{ display: 'inline-flex', textAlign: 'left', marginBottom: '4px' }}>
                                <b>Practice Name:</b>&nbsp;{practiceInformation?.practice_name}
                              </span>
                              <span style={{ display: 'inline-flex', textAlign: 'left', marginBottom: '4px' }}>
                                <b>Username:</b>&nbsp;{userInformation?.username}
                              </span>
                              <span style={{ display: 'inline-flex', textAlign: 'left' }}>
                                <b>Password:</b>&nbsp;{userInformation?.password}
                              </span>
                            </p>
                          </div>
                        :
                          <p className="docpro_mb_0 docpro_fs_16">
                            You want to <span className="docpro_green_color font-semibold">{name}</span>?
                          </p>
                      :
                        <p className="docpro_mb_0 docpro_fs_16">
                          You want to delete this record? This action cannot be undone.
                        </p>
                      }
                      <Spacing lg="32" sm="32" />
                    </div>
                  </div>
                  <div className="docpro_modal_btns small_buttons docpro_mt_auto">
                    {type === 'onboarding_success' ? (
                      <>
                        <button
                          type="button"
                          className="docpro_bordered_btn docpro_fw_600 size_lg"
                          style={{ padding: '12px 30px', minWidth: '130px' }}
                          onClick={() => {actionType();}}
                        >
                          Close
                        </button>
                        <button
                          type="button"
                          className="docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg docpro_btn_green"
                          style={{ minWidth: '130px' }}
                          onClick={() => {actionType(true);}}
                        >
                          Login Into This Practice
                        </button>
                      </>
                    ) : (
                      <>
                        {type === 'recording' ?
                          <button
                            className="docpro_bordered_btn docpro_fw_600 size_lg"
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              handleDrawerClose();
                              setOpacityClass("docpro_opaciry_1");
                            }}
                          >
                            No
                          </button>
                        :
                          <button
                            className="docpro_bordered_btn docpro_fw_600 size_lg"
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              handleDrawerClose();
                            }}
                          >
                            {type === 'package'?
                              'No'
                            :
                              'Cancel'
                            }
                          </button>
                        }
                        {type === 'recording' ?
                          <button
                            className="docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg docpro_btn_green"
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              handleDrawerClose();
                              stopRecording();
                              set_active_modal(false);
                            }}
                          >
                            Yes
                          </button>
                        :
                          <button
                            className={`docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg ${(type === 'delete' || type === 'package') ? 'docpro_btn_red' : 'docpro_btn_green'}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              actionType();
                              handleDrawerClose();
                            }}
                          >
                            Yes
                          </button>
                        }
                      </>
                    )}
                  </div>
                </div>
                <Spacing lg="0" sm="20" />
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
